module.exports = __webpack_public_path__ + "static/media/26UNRWA2.885fa32c.jpg";